import * as types from '../constants/ActionTypes';

const initialState = {
    message: null
};

export default function errorUserNotification(state = initialState, action) {
    switch (action.type) {
        case types.CALL_T2P_FAILURE:
            return {
                ...state,
                message:
                    'Si è verificato un errore durante l’esportazione. Contatta l’assistenza di Zanichelli per risolvere il problema. Ci scusiamo per il disagio.'
            };
        case types.CHECK_FILE_EXISTENCE_FAILURE:
        case types.SAVE_HOMEWORK_FAILURE:
        case types.SAVE_EXERCISE_FAILURE:
        case types.UPDATE_EXERCISE_FAILURE:
        case types.DELETE_EXERCISE_FAILURE:
            return {
                ...state,
                message: 'Questa azione al momento non è disponibile, riprova più tardi. Ci scusiamo per il disagio.'
            };
        case types.SEARCH_EDITORIAL_HOMEWORK_FAILURE:
        case types.GET_HOMEWORK_LIST_FAILURE:
        case types.GET_INVALSI_HOMEWORK_LIST_FAILURE:
            return {
                ...state,
                message: 'Le verifiche momentaneamente non sono disponibili, riprova più tardi. Ci scusiamo per il disagio.'
            };
        case types.RESET_MESSAGE_ERROR:
            return {
                ...state,
                message: ''
            };
        case types.CLEAR_ERROR_USER_NOTIFICATION:
            return initialState;
        default:
            return state;
    }
}
